import React, { useState, useEffect } from 'react';
import C from '../../data/colors';
import { getDeletedGuests, restoreGuest, permanentDeleteGuest } from '../../data/api';
import { RotateCcw, Trash2, X } from 'lucide-react';

const TrashModal = ({ onClose, onRestore }) => {
  const [guests, setGuests] = useState([]);

  const load = async () => { try { setGuests(await getDeletedGuests()); } catch(e) { console.error(e); } };
  useEffect(() => { load(); }, []);

  const handleRestore = async (id) => { await restoreGuest(id); load(); onRestore(); };
  const handlePermanent = async (id) => { if(window.confirm('Permanently delete this guest?')) { await permanentDeleteGuest(id); load(); } };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.bgCard, borderRadius: 16, padding: 28, maxWidth: 500, width: '90%', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.4)', border: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ fontSize: 18, fontWeight: 600, color: C.textPrimary }}><Trash2 size={18} style={{ verticalAlign: 'middle', marginRight: 8 }}/>Trash Bin ({guests.length})</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textSecondary }}><X size={20}/></button>
        </div>
        {guests.length === 0 ? <div style={{ textAlign: 'center', padding: 24, color: C.textSecondary }}>Trash is empty.</div> :
          guests.map(g => (
            <div key={g.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: `1px solid ${C.border}` }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500, color: C.textPrimary }}>{g.first_name} {g.last_name}</div>
                <div style={{ fontSize: 12, color: C.textSecondary }}>{g.email}</div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => handleRestore(g.id)} title="Restore" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#22c55e' }}><RotateCcw size={16}/></button>
                <button onClick={() => handlePermanent(g.id)} title="Permanently delete" style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.error }}><Trash2 size={16}/></button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default TrashModal;
